import { put, call } from 'redux-saga/effects';
import {
  getFarmDetailsError,
  getFarmDetailsSuccess,
} from '../../reducers/farmDetailsSlice';
import withLoading from '../../sagas/loadingSaga';
import { getUuid } from '../Vector/mfrchart/Util';
import { requestDictionary } from '../../common/requestUtil';
import { GET_FARM_ENTITIES_SERVICE_URL } from '../../api/lelyBackend/config';

export default function* handleFarmDetails(api, action) {
  try {
    yield* withLoading(function* () {
      const { farmId, farmName } = action.payload;
      const farmDetails = yield call(api.getFarmEntity, farmId);
      const requestUuid = getUuid();
      requestDictionary[GET_FARM_ENTITIES_SERVICE_URL] = requestUuid;
      const { entities, farmTimeZone } = farmDetails.data;

      yield put(
        getFarmDetailsSuccess(
          {
            farmId,
            farmName,
            farmEntities: entities,
            farmTimeZone,
          },
          requestUuid,
        ),
      );
    });
  } catch (error) {
    yield put(getFarmDetailsError(error));
  }
}
